import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Check } from "lucide-react";
import DemoRequest from "../components/sections/DemoRequest";
import { useI18n } from "../i18n/I18nProvider";
import { getIndustries } from "../i18n/content";

export default function IndustriesPage() {
  const { t, locale } = useI18n();
  const industries = getIndustries(locale);
  return (
    <div data-testid="industries-page">
      <section className="py-24 sm:py-32 border-b border-zinc-200 relative overflow-hidden">
        <div className="absolute inset-0 technical-grid pointer-events-none" />
        <div className="container-oj relative">
          <div className="text-xs font-bold uppercase tracking-[0.25em] text-zinc-500">{t("industries_page.eyebrow")}</div>
          <h1 className="font-display mt-4 text-balance text-5xl sm:text-7xl font-black tracking-tighter leading-[0.92] text-oj-ink max-w-4xl">
            {t("industries_page.h1_a")}<br />{t("industries_page.h1_b")}
          </h1>
          <p className="mt-5 max-w-2xl text-lg text-zinc-600">
            {t("industries_page.intro")}
          </p>
        </div>
      </section>

      <section className="py-16 sm:py-24 bg-zinc-50">
        <div className="container-oj grid grid-cols-1 md:grid-cols-2 gap-6">
          {industries.map((s, i) => (
            <article
              key={s.slug}
              id={s.slug}
              data-testid={`segment-${s.slug}`}
              className="group rounded-2xl p-10 text-white scroll-mt-24 relative overflow-hidden hover:-translate-y-1 transition-transform duration-300"
              style={{ background: s.color }}
            >
              <div className="absolute inset-0 noise opacity-30 mix-blend-overlay pointer-events-none" />
              <div className="relative flex items-center justify-between">
                <span className="font-mono text-[11px] uppercase tracking-[0.25em] opacity-80">/{String(i + 1).padStart(2, "0")} · {s.slug}</span>
                <ArrowUpRight className="size-5 opacity-80 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
              </div>
              <h2 className="relative mt-10 font-display text-3xl sm:text-4xl font-black tracking-tighter leading-none">{s.name}</h2>
              <p className="relative mt-3 text-white/90 text-lg max-w-md">{s.blurb}</p>
              <ul className="relative mt-6 grid grid-cols-1 sm:grid-cols-2 gap-2 text-white/95">
                {s.points.map((p) => (
                  <li key={p} className="flex items-start gap-2 text-sm">
                    <Check className="size-4 mt-0.5 shrink-0" />
                    {p}
                  </li>
                ))}
              </ul>
              <Link
                to="/#demo"
                className="relative mt-8 inline-flex items-center gap-1.5 bg-white/15 hover:bg-white/25 backdrop-blur text-white font-semibold px-4 py-2.5 rounded-md text-sm transition-colors"
                data-testid={`segment-cta-${s.slug}`}
              >
                {t("industries_page.book_demo_for")} {s.name} <ArrowUpRight className="size-4" />
              </Link>
            </article>
          ))}
        </div>
      </section>
      <DemoRequest />
    </div>
  );
}
